// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3569":"bd536a85","5635":"a9e72238"}[chunkId] + ".chunk.css";
};